import axios from 'axios'
import { REACT_APP_API } from '../../config'
import { getQueryConfig } from 'src/features/price-policies/constants'

export const getBrandsByCarLots = async (params) => {
    const {carLots} = params

    if (!carLots) return
    let query = ''

    carLots.forEach(id => {
        query = query + 'car_lot_id[]=' + id + '&'
    })

    query = query.slice(0, -1)

    const queryConfig = getQueryConfig(params)

    const { data } = await axios(`${REACT_APP_API}/bonifications/brandsForBonification?${query}&${queryConfig}`)

    return data
}